import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum TrailFinderQuestionSectionIds {
  general = 'general',
}

/**
 * @description Sections shared by the Trail Finder Question detail page and edit form, in display order.
 */
export const trailFinderQuestionSections: SectionDefinition[] = [
  {
    id: TrailFinderQuestionSectionIds.general,
    title: 'General',
    description: 'Question text, display order, and visibility.',
    icon: InfoOutlinedIcon,
  },
]
